module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-modern-1-48fbf17954c378918cc979a4b1491f8f.webp";